export const getLastPathSegment = (pathname: string | null | undefined): string | undefined => {
  if (!pathname) {
    return undefined;
  }
  const segments = pathname.split("/").filter(Boolean);
  return segments[segments.length - 1];
};
